<template>
  <div class="a404">
    <img src="/web/static/images/disappear.png" alt="">
  </div>
</template>

<script>
  export default {
    name: "disappear"
  }
</script>

<style scoped type="text/css" lang="scss">
  .a404 {
    display: flex;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    background: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/disappear.vue